// extracted by css-extract-rspack-plugin
export default {"archiveMenuItem":"GndSi"};